import { deriveStars, type PettownStar } from "./pettown.ts";
import { type Money, toBig, divRound } from "./big.ts";
import { eMilliOf } from "./curve.ts";
import { type Globals } from "./model.ts";
import type { RivalDef } from "./fixtures";
import { curveMetricsFor, type EconomySeries } from "./economy-curves.ts";
export function pettownSeries(maxStar:number, rows:PettownStar[], g:Globals, rivals:RivalDef[], prices:Record<string,Record<number,Money>>, dice:number|null):EconomySeries[] {
 const source = { ...g, unifiedB:g.unifiedB ? 1:0, rivalPrices:prices };
 const out:EconomySeries[]=[];
 for(const id of ["formula","manual",...rivals.map(r=>r.id)]) {
  const stars=deriveStars(maxStar,rows,g.E,g.rho,{...source,costSource:id==="formula"||id==="manual"?id:`rival:${id}`,economyModel:g.economyModel});
  const gOf=new Map(rows.map(r=>[r.star,toBig(r.gMilli)]));
  // model 2：E、收入 B 不画；每骰产出就是这颗星的 g，与造价来源无关
  for(const metric of curveMetricsFor(g.economyModel)) {
   if(id!=="formula"&&(["rolls","E","rho","dice"].includes(metric)||(metric==="perRoll"&&g.economyModel===2)))continue;
   out.push({id:`${metric}:${id}`,source:id,metric,scale:metric==="E"?1000:metric==="rho"?10000:1,points:stars.map(r=>{
    const missing=id==="manual"?r.manual==null:id!=="formula"?r.rivals[id]==null:false;
    let value:bigint|null=null;
    if(metric==="cost")value=missing?null:id==="formula"?r.formula:id==="manual"?r.manual:r.rivals[id];
    else if(metric==="income")value=missing?null:r.runtimeB??null;
    else if(metric==="perRoll"&&g.economyModel===2){const gm=gOf.get(r.star);value=gm==null?null:divRound(gm,1000n);}
    else if(metric==="perRoll")value=missing||r.runtimeB==null?null:divRound(r.runtimeB*eMilliOf(g.E),1000n);
    else if(metric==="rolls")value=r.rolls;
    else if(metric==="E")value=Number.isFinite(g.E)&&g.E>0?eMilliOf(g.E):null;
    else if(metric==="rho")value=Number.isFinite(g.rho)&&g.rho>0?BigInt(Math.round(g.rho*10000)):null;
    else value=toBig(dice);
    return {n:r.star,value:r.bad?null:value??null};
   })});
  }
 }
 return out;
}
